import { User } from "../types/User"
import "./Avatar.css";

type Props = {
  user: User;
}

export default function Avatar({ user }: Props) {
  return (
    <div className="d-flex avatar-card">
      <strong>{ user.nome.substring(0, 1) }{ user.cognome.substring(0, 1) }</strong>
    </div>
  )
}